export const getToday = () => new Date();
